import axios from "axios";
import { default as config } from "@src/config";

export function route(url, params = {}, hasBaseURL = true) {
    for (let key in params) {
        url = url.replaceAll(`:${ key }`, params[key]);
    }

    return hasBaseURL ? `${ config.API_HOST }/${ config.API_PREFIX }/${ url }` : url;
}

export function pageRoute(url, params = {}, hasBaseURL = true, query = {}) {
    for (let key in params) {
        url = url.replaceAll(`:${ key }`, params[key]);
    }

    url = hasBaseURL ? `${ config.BASE_URL }/${ url }` : url;
    if (Object.keys(query).length == 0) {
        return url;
    }
    const queries = Object.keys(query).map(key => `${ key }=${ query[key] }`).join("&");
    return url.includes("?")
        ? `${ url }${ queries }`
        : `${ url }?${ queries }`;
    
}

export function pageBackend(url, params = {}, hasBaseURL = true) {
    for (let key in params) {
        url = url.replaceAll(`:${ key }`, params[key]);
    }

    return hasBaseURL ? `${ config.API_HOST }/${ url }` : url;
}

export function resource(url) {
    return `${ config.BASE_URL }/${ url }`;
}

export function getHeaders() {
    let token = localStorage.getItem("auth_token");

    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Timezone-Offset": 8,
    };
    if (token) {
        headers.Authorization = `Bearer ${ JSON.parse(token).access_token }`;
    }

    return headers;
}


export function request(method, url, options = {}) {
    return new Promise((resolve, reject) => {
        axios({
            method, url,
            headers: options.headers || getHeaders(),
            params: options.params || {},
            data: options.data || {},
        })
            .then(response => resolve(response))
            .catch(error => {
                const response = JSON.parse(error.response.request.response)
                
                if (response.statusCode === 404 && response.result.exception === "The token has been blacklisted") {
                    window.location = pageRoute("logout");

                } else if (error.response.status === 401 && error.response.statusText === "Unauthorized") {
                    window.location = pageRoute("logout");
                }

                reject(error)
            })
    })
}

export function get(url, options = {}) {
    return request("get", url, options)
}

export function post(url, options = {}) {
    return request("post", url, options)
}

export function put(url, options = {}) {
    return request("put", url, options)
}

export function patch(url, options = {}) {
    return request("patch", url, options)
}

export function destroy(url, options = {}) {
    return request("delete", url, options)
}